import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  onRetry?: () => void;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="absolute inset-0 bg-white/80 flex items-center justify-center">
          <div className="text-center p-4">
            <ExclamationTriangleIcon className="h-8 w-8 text-amber-500 mx-auto" />
            <p className="mt-2 text-sm text-gray-600">
              {this.state.error?.message || 'Something went wrong'}
            </p>
            {this.props.onRetry && (
              <button
                className="mt-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={() => {
                  this.setState({ hasError: false });
                  this.props.onRetry?.();
                }}
              >
                Retry
              </button>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}